<mat-card *ngIf="!isRepsol && !isGS">
  <h2>
    {{ (interviniente ? 'intervinentSocioeconomicData.title' : 'socioeconimicData.title') | translate }}
    {{ numInterviniente }}
  </h2>
  <form [formGroup]="socioeconomicDataForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <!--Row-->
      <div fxFlex="100" [fxFlex.gt-sm]="isMG || isBP ? 40 : 30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="laboralSituation"
          [id]="'laboralSituationSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="employmentSituationList"
          [placeholder]="'socioeconimicData.laboralSituation'"
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.laboralSituation?.errors"
          (selectionChange)="onChangeLaboralSituation($event.value)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="isMG || isBP ? 30 : 40">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="job"
          [id]="'jobSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="professionList"
          [placeholder]="'socioeconimicData.job'"
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.job?.errors"
          (selectionChange)="onChangeJob($event.value)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="enterpriseActivity"
          [id]="'enterpriseActivitySocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="sectorBusinessList"
          [placeholder]="
            isMG || isBP ? 'socioeconimicData.enterpriseActivityCard' : 'socioeconimicData.enterpriseActivity'
          "
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.enterpriseActivity?.errors"
          (selectionChange)="getCnaeByEnterpriseActivity($event.value)"
        ></scf-custom-select-search>
      </div>

      <!--Row-->
      <div fxFlex="50" [fxFlex.gt-sm]="isMG || isBP ? 40 : 30">
        <mat-form-field yearMonthDirective fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.enterpriseAntiquity</mat-label>
          <input
            [id]="'enterpriseAntiquitySocioeconomicData' + (interviniente ? numInterviniente : '')"
            matInput
            maxlength="7"
            [matDatepicker]="datepicker"
            formControlName="enterpriseAntiquity"
            [max]="currentDate"
            [min]="minDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker
            [id]="'enterpriseActivityDatePicker' + (interviniente ? numInterviniente : '')"
            #datepicker
            startView="multi-year"
            (monthSelected)="chosenMonthHandler($event, datepicker)"
            (yearSelected)="chosenYearHandler($event)"
          ></mat-datepicker>
          <mat-error
            *ngIf="
              socioeconomicDataForm.controls.enterpriseAntiquity.hasError('required') &&
              !socioeconomicDataForm.controls.enterpriseAntiquity.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.enterpriseAntiquity.hasError('matDatepickerMax')" translate>
            field.error.maxDateToCurrent
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.enterpriseAntiquity.hasError('matDatepickerMin')" translate>
            field.error.minDate
          </mat-error>
          <mat-error
            *ngIf="socioeconomicDataForm.controls.enterpriseAntiquity.hasError('matDatepickerParse')"
            translate
          >
            field.error.parseDateMonth
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="isMG || isBP ? 30 : 40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.enterpriseName</mat-label>
          <input
            [id]="'enterpriseNameSocioeconomicData' + (interviniente ? numInterviniente : '')"
            formControlName="enterpriseName"
            matInput
            type="text"
            maxlength="25"
            autocomplete="off"
          />
          <mat-hint *ngIf="isAutonomo" translate>request.optional</mat-hint>
          <mat-error *ngIf="socioeconomicDataForm.controls.enterpriseName.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.cif</mat-label>
          <input
            [id]="'cifSocioeconomicData' + (interviniente ? numInterviniente : '')"
            #cifSocioeconomicData
            formControlName="nifOrCif"
            matInput
            type="text"
            maxlength="9"
            (blur)="validateCif()"
            autocomplete="off"
          />
          <mat-hint *ngIf="isConsumo || isAutonomo" translate>request.optional</mat-hint>
          <mat-error *ngIf="socioeconomicDataForm.controls.nifOrCif.hasError('required')" translate>
            field.required
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.nifOrCif.hasError('dniInvalid')" translate>
            field.incorrect
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.nifOrCif.hasError('shouldbecif')" translate>
            field.error.shouldbecif
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.nifOrCif.hasError('nifautonomo')" translate>
            field.error.nifautonomo
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.nifOrCif.hasError('nifigualcif')" translate>
            field.error.nifigualcif
          </mat-error>
        </mat-form-field>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.enterpriseProvince</mat-label>
          <input
            [id]="'enterpriseProvinceSocioeconomicData' + (interviniente ? numInterviniente : '')"
            formControlName="enterpriseProvince"
            matInput
            type="text"
            maxlength="25"
            autocomplete="off"
            (keypress)="lettersOnly($event)"
            (paste)="lettersOnly($event)"
          />
          <mat-error *ngIf="socioeconomicDataForm.controls.enterpriseProvince.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.enterpriseTelephone</mat-label>
          <input
            [id]="'enterpriseTelephoneSocioeconomicData' + (interviniente ? numInterviniente : '')"
            formControlName="enterpriseTelephone"
            matInput
            type="text"
            maxlength="9"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error *ngIf="socioeconomicDataForm.controls.enterpriseTelephone.invalid" translate>
            field.error.telefono.empresa
          </mat-error>
        </mat-form-field>
      </div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="isConsumo || isAuto">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="originsRevenue"
          [id]="'originsRevenueSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="originsRevenueList"
          [placeholder]="'socioeconimicData.incomeType'"
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.originsRevenue?.errors"
          (selectionChange)="onChangeOriginsRevenue($event)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="0" fxFlex.gt-sm="60" *ngIf="isConsumo || isAuto"></div>

      <!--Row-->
      <div fxFlex="50" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.incomeMonthly</mat-label>
          <input
            [id]="'incomeMonthlySocioeconomicData' + (interviniente ? numInterviniente : '')"
            #incomeMonthly
            matInput
            formControlName="incomeMonthly"
            (keypress)="numberOnly($event, incomeMonthly)"
            (blur)="onIncomeMonthlyBlur($event, incomeMonthly)"
            autocomplete="off"
          />
          <mat-error *ngIf="socioeconomicDataForm.controls.incomeMonthly.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.incomeOther</mat-label>
          <input
            [id]="'incomeOtherSocioeconomicData' + (interviniente ? numInterviniente : '')"
            #incomeOther
            matInput
            formControlName="incomeOther"
            (keypress)="numberOnly($event, incomeOther)"
            (blur)="transformAmount($event, incomeOther)"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
        </mat-form-field>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.incomeAnnual</mat-label>
          <input
            [id]="'incomeAnnualSocioeconomicData' + (interviniente ? numInterviniente : '')"
            #incomeAnnual
            matInput
            formControlName="incomeAnnual"
            (keypress)="numberOnly($event, incomeAnnual)"
            (blur)="transformAmount($event, incomeAnnual)"
            autocomplete="off"
          />
          <mat-hint *ngIf="!isAutonomo" translate>request.optional</mat-hint>
          <mat-error *ngIf="isAutonomo || socioeconomicDataForm.controls.incomeAnnual.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>

      <!--Row-->
      <div fxFlex="100" fxFlex.gt-sm="70">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="cnae"
          [id]="'cnaeSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="cnaeList"
          [placeholder]="'socioeconimicData.cnae'"
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.cnae?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="0" fxFlex.gt-sm="30"></div>

      <!--Row-->
      <div fxFlex="50" [fxFlex.gt-sm]="isMG || isBP || isMgWithShopping ? 40 : 30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="livingSituation"
          [id]="'livingSituationSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="residentialSituationList"
          [placeholder]="'socioeconimicData.livingSituation'"
          [isRequired]="true"
          [showErrors]="socioeconomicDataForm?.controls?.livingSituation?.errors"
          (selectionChange)="onChangeLivingSituation($event?.value)"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isConsumo || isAuto">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>socioeconimicData.livingExpenses</mat-label>
          <input
            [id]="'livingExpensesSocioeconomicData' + (interviniente ? numInterviniente : '')"
            #livingExpenses
            matInput
            formControlName="livingExpenses"
            (keypress)="numberOnly($event, livingExpenses)"
            (blur)="transformAmount($event, livingExpenses)"
            autocomplete="off"
          />
          <mat-hint *ngIf="isLivingExpensesOptional" translate>request.optional</mat-hint>
          <mat-error *ngIf="socioeconomicDataForm.controls.livingExpenses.hasError('required')" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isMG || isBP || isMgWithShopping">
        <mat-form-field fxFlex="100" appearance="outline" yearDirective>
          <mat-label translate>socioeconimicData.livingAntiquity</mat-label>
          <input
            [id]="'livingAntiquitySocioeconomicData' + (interviniente ? numInterviniente : '')"
            matInput
            [matDatepicker]="datepickerlivingAntiquity"
            formControlName="livingAntiquity"
            [max]="currentDate"
            [min]="minDate"
            autocomplete="off"
          />
          <mat-datepicker-toggle matSuffix [for]="datepickerlivingAntiquity"></mat-datepicker-toggle>
          <mat-datepicker
            [id]="'livingAntiquitySocioeconomicData' + (interviniente ? numInterviniente : '')"
            #datepickerlivingAntiquity
            startView="multi-year"
            (yearSelected)="chosenOnlyYearHandler($event, datepickerlivingAntiquity)"
          ></mat-datepicker>
          <mat-error
            *ngIf="
              socioeconomicDataForm.controls.livingAntiquity.hasError('required') &&
              !socioeconomicDataForm.controls.livingAntiquity.hasError('matDatepickerParse')
            "
            translate
          >
            field.required
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.livingAntiquity.hasError('matDatepickerMax')" translate>
            field.error.maxDateToCurrent
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.livingAntiquity.hasError('matDatepickerMin')" translate>
            field.error.minDate
          </mat-error>
          <mat-error *ngIf="socioeconomicDataForm.controls.livingAntiquity.hasError('matDatepickerParse')" translate>
            field.error.parseDateYear
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="30" *ngIf="isMG || isBP || isMgWithShopping">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="peopleInCharge"
          [id]="'peopleInChargeSocioeconomicData' + (interviniente ? numInterviniente : '')"
          [dataInput]="numPersonInChargeList"
          [placeholder]="'socioeconimicData.peopleInCharge'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="socioeconomicDataForm?.controls?.peopleInCharge?.errors"
        ></scf-custom-select-search>
      </div>
    </div>
  </form>
</mat-card>
